module.exports = __webpack_public_path__ + "static/img/Bachelor_010809.4e007a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010809.jpg
// module id = 253
// module chunks = 0